module.exports = __webpack_public_path__ + "static/media/footerImg.c9b60c51.png";